import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { useAuthStore } from '@/store/authStore';

/**
 * Centralized Axios instance for API requests
 * Configured with base URL, credentials, and interceptors
 */
export const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Request interceptor for additional configuration
 * Kratos uses cookies for authentication, so no token header needed
 */
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Kratos handles authentication via cookies automatically
    // No need to add Authorization header
    return config;
  },
  (error: AxiosError) => Promise.reject(error)
);

/**
 * Response interceptor for error handling
 * Handles 401 errors by clearing session and redirecting to login
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearSession();
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);
